
<div>
  <nav class="navbar navbar-expand navbar-light bg-light" id="navbar" style="width:100%;">
    <ul class="navbar-nav mr-auto" style="width: 33%;">
      <li class="nav-item">
        <a class="nav-link"   >
          <img src="assets/img/logos/logo_ummi.png" style="width:50%; height:50%" >
        </a>
      </li>
    </ul>
    <ul class="navbar-nav" style="width: 34%;">
      <li class="nav-item">
        <a class="nav-link"  >
        <h1>Escuela de Ciencias</h1>
        </a>
      </li>
    </ul>
    <ul class="navbar-nav" style="width: 33%;" >
      <li class="nav-item">
        <a class="nav-link" >
          <img src="assets/img/logos/logo_usac.png" style="width:50%; height:50%; float:right;" >
        </a>
      </li>
    </ul>
   <!-- <span>
      <button class="btn btn-primary" (click)="login()"> Llenar encuesta </button>
      <button class="btn btn-primary" *ngIf="isAuthenticated" (click)="logout()"> Logout </button>
    </span> -->
  </nav>
  <div class="container-fluid mt-4">
      <div class="row ">
          <div class="col-12">
            <router-outlet></router-outlet>
          </div>
      </div>
  </div>

</div>

